export enum ClipboardScoreActions {
  WORK_SHIFT = "WORK_SHIFT",
  CANCEL_SHIFT = "CANCEL_SHIFT",
  NO_CALL_NO_SHOW = "NO_CALL_NO_SHOW",
  CORRECT_SCORE = "CORRECT_SCORE",
  ACCOUNT_RE_ENROLL = "ACCOUNT_RE_ENROLL",
  START_SHIFT_LATE = "START_SHIFT_LATE",
  CLOCKIN_TIMELINESS_BONUS = "CLOCKIN_TIMELINESS_BONUS",
  QUALITY_BONUS = "QUALITY_BONUS",
  CLIPBOARD_SCORE_LAUNCH = "CLIPBOARD_SCORE_LAUNCH",
  WORKER_LEFT_EARLY_WITHOUT_PERMISSION = "WORKER_LEFT_EARLY_WITHOUT_PERMISSION",
  ORIENTATION_PASSED = "ORIENTATION_PASSED",
  ORIENTATION_ACTIVATION = "ORIENTATION_ACTIVATION",
  ORIENTATION_DEACTIVATION = "ORIENTATION_DEACTIVATION",
  CUSTOM_BONUS = "CUSTOM_BONUS",
  IN_HOME_NO_LOG = "IN_HOME_NO_LOG",
  IN_HOME_NO_CONFIRMATION = "IN_HOME_NO_CONFIRMATION",
  IN_HOME_VISIT_DROPPED = "IN_HOME_VISIT_DROPPED",
  IN_HOME_VISIT_APPROVED = "IN_HOME_VISIT_APPROVED",
  SIGN_UP_BONUS = "SIGN_UP_BONUS",
  REDEEM_SCORE = "REDEEM_SCORE",
  GROUP_ATTENDANCE = "GROUP_ATTENDANCE",
  ADD_FRIEND_BONUS = "ADD_FRIEND_BONUS",
  ON_CALL_SHIFT_CLAIMED = "ON_CALL_SHIFT_CLAIMED",
  ON_CALL_SHIFT_CANCELED = "ON_CALL_SHIFT_CANCELED",
  ON_CALL_SHIFT_WORKER_CANCELLED = "ON_CALL_SHIFT_WORKER_CANCELLED",
  ON_CALL_SHIFT_SYSTEM_CANCELLED = "ON_CALL_SHIFT_SYSTEM_CANCELLED",
}

export const clipboardScoreActionLabelMap: Record<ClipboardScoreActions, string> = {
  WORK_SHIFT: "Worked Shift",
  CANCEL_SHIFT: "Cancellation",
  NO_CALL_NO_SHOW: "No Show",
  CORRECT_SCORE: "Score Correction",
  ACCOUNT_RE_ENROLL: "Account Re-enrolled",
  START_SHIFT_LATE: "Shift Started Late",
  CLOCKIN_TIMELINESS_BONUS: "Arrived on time",
  QUALITY_BONUS: "Excellence Bonus",
  CLIPBOARD_SCORE_LAUNCH: "Clipboard Score Launch",
  WORKER_LEFT_EARLY_WITHOUT_PERMISSION: "Shift Abandonment",
  ORIENTATION_PASSED: "Demo shift completed",
  ORIENTATION_ACTIVATION: "Demo shift activated",
  ORIENTATION_DEACTIVATION: "Demo shift deactivated",
  CUSTOM_BONUS: "Custom Bonus",
  IN_HOME_NO_LOG: "In-Home: No Visit Logged",
  IN_HOME_NO_CONFIRMATION: "In-Home: No Confirmation",
  IN_HOME_VISIT_DROPPED: "In-Home: Visit Dropped",
  IN_HOME_VISIT_APPROVED: "In-Home: Visit Approved",
  SIGN_UP_BONUS: "Sign-up Bonus",
  REDEEM_SCORE: "Redeem Score",
  GROUP_ATTENDANCE: "Group Attendance",
  ADD_FRIEND_BONUS: "Add Friend Bonus",
  ON_CALL_SHIFT_CLAIMED: "On-Call Shift Claimed",
  ON_CALL_SHIFT_CANCELED: "On-Call Shift Cancelled",
  ON_CALL_SHIFT_WORKER_CANCELLED: "On-Call Shift Worker Cancelled",
  ON_CALL_SHIFT_SYSTEM_CANCELLED: "On-Call Shift System Cancelled",
};

export const reasonDisplayMap: Record<string, Record<string, string>> = {
  [ClipboardScoreActions.START_SHIFT_LATE]: {
    SECOND_IN_DOUBLE:
      "You didn't lose points for this penalty because the shift was a second in a double.",
    SHORT_LEAD_TIME_BOOKING:
      "You didn't lose points for this penalty because the shift was picked up within 4 hours of the start time.",
    GRACE_PERIOD:
      "You missed out on the timeliness bonus. Plan ahead for traffic and aim to arrive early to lock it in next shift.",
  },
  [ClipboardScoreActions.CLOCKIN_TIMELINESS_BONUS]: {
    SECOND_IN_DOUBLE:
      "You didn't earn bonus points for arriving on time because this shift was the second in a double.",
  },
};
